module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header clearfix"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Отказ",
      "to": "/moderate/category/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Запис"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1)])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('f-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "category_name",
      "errors": _vm.errorBag.collect('category_name'),
      "cplaceholder": '(пример: Четене)'
    },
    model: {
      value: (_vm.category.name),
      callback: function($$v) {
        _vm.$set(_vm.category, "name", $$v)
      },
      expression: "category.name"
    }
  }), _vm._v(" "), _c('f-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "category_scope",
      "errors": _vm.errorBag.collect('category_scope'),
      "values": _vm.$config.lists.categoryScopes
    },
    model: {
      value: (_vm.category.scope),
      callback: function($$v) {
        _vm.$set(_vm.category, "scope", $$v)
      },
      expression: "category.scope"
    }
  }), _vm._v(" "), _c('f-category', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (''),
      expression: "''"
    }],
    attrs: {
      "name": "category_parent",
      "errors": _vm.errorBag.collect('category_parent'),
      "csingle": true
    },
    model: {
      value: (_vm.category.parent),
      callback: function($$v) {
        _vm.$set(_vm.category, "parent", $$v)
      },
      expression: "category.parent"
    }
  })], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-088abbf7!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/admin/CategoryEdit.vue
// module id = 635
// module chunks = 1